export const headerData = {
    'content-type': 'application/json',
    'Authorization': process.env.REACT_APP_API_AUTH
}
